import React from 'react'

const AutomationOptionsScene = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="57" height="41" viewBox="0 0 57 41" fill="none" className={className}>
    <path
      d="M33.4805 25.58V18.8L39.3405 22.1901L45.2105 25.58L39.3405 28.96L33.4805 32.35V25.58Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M36.87 39.74H20.12H10.7H1.5V17.81L10.35 9.65L19.18 1.5L23.78 5.75" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M33.0892 5.84L28.3792 1.5L23.7792 5.75L21.3592 7.99L19.5392 9.65L10.6992 17.81V39.74H20.1192H36.8692H46.0592"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M55.4909 17.8L46.6509 9.65L37.8109 1.5L28.9709 9.65L20.1309 17.8V39.74H55.4909V17.8Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default AutomationOptionsScene
